<ngx-doc-viewer *ngIf="docUrl" [url]="docUrl" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
